import { BaseQueryFn, createApi } from '@reduxjs/toolkit/query/react';
import rtkBaseQuery from '../../../utils/rtk-base-query';

export const versionCheckApi = createApi({
  reducerPath: 'versionCheckApi',
  baseQuery: rtkBaseQuery({ baseUrl: '/api/v2' }) as BaseQueryFn,
  endpoints: (builder) => ({
    getVersion: builder.query({
      query: ({ params }) => ({
        url: '/utils/getVersion',
        method: 'GET',
        params,
      }),
    }),
  }),
});

export const { useGetVersionQuery } = versionCheckApi;
